import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fanhearts.com/fanhearts.com/src/app/peacecover/_components/PeacecoverPageClient.tsx");
